module.exports = __webpack_public_path__ + "static/media/animated-triangles--black.b9e7db60.gif";